// extracted by mini-css-extract-plugin
export var subtitle = "_bl-2";
export var title = "_bl-0";
export var titleNoWrap = "_bl-1";